/* 🤖 this file was generated by script */
export const wiconUser01 = {
  name: 'user_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 21c0-1.4 0-2.1-.17-2.66a4 4 0 00-2.67-2.67c-.57-.17-1.26-.17-2.66-.17h-5c-1.4 0-2.1 0-2.66.17a4 4 0 00-2.67 2.67C4 18.9 4 19.6 4 21M16.5 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z"/></svg>`,
};
